<template>
  <!--  视频找房-->
  <div class="poor">
    <div class="poor_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="楼盘名字">
                <el-input
                  placeholder="请输入名称"
                  v-model="searchData.floorName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="标题">
                <el-input
                  placeholder="请输入标题"
                  v-model="searchData.title"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="置业经理">
                <el-input
                  placeholder="请输入名字"
                  v-model="searchData.salesmanName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.examineStatus"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in newsStatus"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-checkbox
                :false-label="0"
                :true-label="1"
                v-model="searchData.isJingjirenjianfang"
                >经纪人推荐</el-checkbox
              >
              <el-checkbox
                :false-label="0"
                :true-label="1"
                v-model="searchData.isKaipanshixian"
                >开盘视线</el-checkbox
              >
              <el-checkbox
                :false-label="0"
                :true-label="1"
                v-model="searchData.isZhuanyejianfang"
                >专业荐房</el-checkbox
              >
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="开盘视线">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.isKaipanshixian"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="专业推荐">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.isZhuanyejianfang"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经纪人推荐">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.isJingjirenjianfang"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>

          <!-- <el-row>
            <el-cascader
              :options="options"
              :props="props"
              clearable
            ></el-cascader>
          </el-row> -->

          <el-form-item>
            <el-button
              size="mini"
              style="width: 90px; margin-left: 120px"
              type="primary"
              @click="messageAdd"
              v-if="menuPerm('floorVideo:insert')"
              >添加</el-button
            >
            <el-button
              size="mini"
              style="margin-left: 20px"
              type="primary"
              @click="messageSearch"
              >查询</el-button
            >

            <el-button
              size="mini"
              style="margin-left: 20px"
              type="primary"
              @click="topicClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card v-loading="loading">
        <el-table
          :data="list"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="title"
            label="标题"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="salesmanName"
            label="置业经理"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="floorName"
            label="楼盘名称"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="videoUrl"
            label="视频"
            align="center"
            width="200"
          >
            <template slot-scope="{ row }">
              <video
                :src="row.videoUrl"
                controls="controls"
                style="width: 150px; height: 150px"
              ></video>
            </template>
          </el-table-column>
          <el-table-column
            prop="isZhuanyejianfang"
            label="专业荐房"
            align="center"
            width="80px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.isZhuanyejianfang == 1">是</span>
              <span v-if="row.isZhuanyejianfang == 0">否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="isJingjirenjianfang"
            label="经纪人推荐"
            align="center"
            width="100px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.isJingjirenjianfang == 1">是</span>
              <span v-if="row.isJingjirenjianfang == 0">否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="isKaipanshixian"
            label="开盘视线"
            align="center"
            width="80px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.isKaipanshixian == 1">是</span>
              <span v-if="row.isKaipanshixian == 0">否</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="examineStatus"
            label="审核状态"
            align="center"
            width="180px"
          >
            <template slot-scope="{ row }">
              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                @change="examChange($event, row)"
                v-if="menuPerm('floorVideo:review')"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in newsStatus"
                ></el-option>
              </el-select>

              <div v-if="menuPerm('floorVideo:submitReview')">
                <el-button
                  size="mini"
                  type="danger"
                  v-if="row.examineStatus == 2"
                  >未提交审核</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  v-if="row.examineStatus == 3"
                  >审核中</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  v-if="row.examineStatus == 4"
                  >审核未通过</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  v-if="row.examineStatus == 1"
                  >审核通过</el-button
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="180px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="messageChange(row)"
                  v-if="menuPerm('floorVideo:update')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >修改</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="submitReview(row)"
                  v-if="menuPerm('floorVideo:submitReview')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >提交审核</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="messageDelete(row)"
                  v-if="menuPerm('floorVideo:delete')"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <!-- 修改页面 -->
      <a-drawer
        title="修改"
        :width="1300"
        :visible="changevisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Change :ChangeData="changeData" />
      </a-drawer>
      <!-- 删除弹出框 -->
      <a-modal
        :visible="delOpen"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <p>确定要删除吗？</p>
      </a-modal>
    </div>
  </div>
</template>
<script>
import Change from "./change";
export default {
  components: {
    // Add,
    Change,
  },
  data() {
    return {
      //   props: { multiple: true },
      //   options: [
      //     {
      //       value: 1,
      //       label: "全部",
      //       children: [
      //         { value: 3, label: "普陀" },
      //         { value: 4, label: "黄埔" },
      //         { value: 5, label: "徐汇" },
      //       ],
      //     },
      //   ],
      allOpen: true,
      addvisible: false,
      changevisible: false,
      delOpen: false,
      list: [], //留言列表
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示

      //查询的数据：
      searchData: {
        floorName: "", //楼盘名字
        salesmanName: "", //置业经理
        title: "", //标题
        isKaipanshixian: "", //开盘视线
        isZhuanyejianfang: "", //专业荐房
        isJingjirenjianfang: "", //经纪人荐房
        examineStatus: "", //审核状态
      },
      //类型--下拉框：
      messageType: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      //状态--下拉框：
      newsStatus: [
        {
          value: "2",
          label: "未提交审核",
        },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],
      loading: false,
      addData: [],
      changeData: [],
      deleteId: "",
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //列表：
    getList() {
      this.postAxios("/floorVideo/list", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        floorVideo: {
          floorName: this.searchData.floorName,
          salesmanName: this.searchData.salesmanName, //置业经理
          title: this.searchData.title, //标题
          isKaipanshixian: this.searchData.isKaipanshixian, //开盘视线
          isZhuanyejianfang: this.searchData.isZhuanyejianfang, //专业推荐
          isJingjirenjianfang: this.searchData.isJingjirenjianfang, //经纪人推荐
          examineStatus: this.searchData.examineStatus, //审核状态
        },
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 添加
    messageAdd(row) {
      this.$router.push("/floorVideoAdd");
    },
    //审核接口：
    examChange(ids, examStatus) {
      this.getAxios("/floorVideo/review", {
        id: examStatus.id,
        examineStatus: examStatus.examineStatus,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.getList();
        } else if (res.success == false) {
          this.$message.success(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 提交审核
    submitReview(row) {
      this.getAxios("/floorVideo/submitReview", {
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.getList();
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 修改
    messageChange(row) {
      this.changevisible = true;
      this.changeData = row;
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios(`/floorVideo/delete?id=${this.deleteId}`).then((res) => {
        if (res.success == true) {
          this.getList();
          this.$message.success(res.message);
          this.delOpen = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 删除
    messageDelete(row) {
      this.deleteId = row.id;
      this.delOpen = true;
    },
    onClose() {
      this.addvisible = false;
      this.changevisible = false;
      this.getList();
    },
    //查询列表：
    messageSearch() {
      this.currentPage = 1;
      this.loading = true;
      this.postAxios("/floorVideo/list", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        floorVideo: {
          floorName: this.searchData.floorName,
          salesmanName: this.searchData.salesmanName, //置业经理
          title: this.searchData.title, //标题
          isKaipanshixian: this.searchData.isKaipanshixian, //开盘视线
          isZhuanyejianfang: this.searchData.isZhuanyejianfang, //专业推荐
          isJingjirenjianfang: this.searchData.isJingjirenjianfang, //经纪人推荐
          examineStatus: this.searchData.examineStatus, //审核状态
        },
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;
          this.loading = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //清空查询条件：
    topicClear() {
      this.searchData = {};
      this.getList();
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  created() {
    this.getList(); //获取留言列表
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.poor {
  width: 100%;
  height: 100%;
  .poor_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .done {
      display: flex;
      flex-direction: column;
      width: 100px;

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>